import { worker } from "./browser";

if (typeof window !== "undefined") {
  worker.start({
    serviceWorker: {
      url: "/mockServiceWorker.js",
    },
    onUnhandledRequest: "bypass",
  });
}
